import styled, { css } from 'styled-components';

export const AttributesWrapper = styled.div`
  padding: 20px;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
`;
export const ToggleDetails = styled.div`
`;

export const ArrowIcon = styled.span`
  vertical-align:text-top;
  svg {
    fill:#1C2833;
    ${props => !props.open && css`
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -o-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
      transform: rotate(180deg);
    `}
  }
`;

export const Attribute = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  padding: 6px 0px;
`;

export const Name = styled.div`
  font-weight: 600;
  width: 50%;
  font-size: 14px;
  white-space: nowrap;
`;
export const Value = styled.div`
  width: 50%;
  white-space: nowrap;
  font-size: 14px;
  padding-left: 20px;
`;

export const Action = styled.div`
  position: absolute;
  right: 0;
  svg {
    cursor: pointer;
    color: black;
    max-height: 14px;
  }
`;

export const Icon = styled.div``;

export const MeasuredOn = styled.div`
color: #ccc;
font-size: .85em;
margin-top: 1em;
`;
